import Vue from 'vue'
import VeeValidate from 'vee-validate'
import validationConfig from '@/validation/config'
Vue.use(VeeValidate, validationConfig)
